import { twMerge } from "tailwind-merge";
import { clsx, type ClassValue } from "clsx";

import type { Metadata } from "next";

const isProd = process.env.NODE_ENV === "production";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateMetadata(args?: Metadata): Metadata {
  const title = args?.title || "Crypto Inc.";
  const description =
    args?.description ||
    "Launch your own powerful crypto dashboard with a premium Next.js template, built using Shadcn and TailwindCSS. Perfect for developers and startups, this feature-rich template includes portfolio tracking, rewards, staking, market data, transactions, and customizable settings. Designed for scalability and user engagement, it's the ideal starting point to create an intuitive and visually stunning crypto platform.";
  const domain = new URL(
    isProd
      ? process.env.NEXT_PUBLIC_PROD_URL!
      : process.env.NEXT_PUBLIC_DEV_URL!,
  );
  const productDemoImg = "/product-demo.png";

  return {
    // general
    metadataBase: domain,
    title,
    description,
    alternates: { canonical: domain, ...args?.alternates },

    // open-graph
    openGraph: {
      type: "website",
      url: domain,
      title,
      description,
      images: [
        {
          url: productDemoImg,
        },
      ],
      ...args?.openGraph,
    },

    // twitter
    twitter: {
      card: "summary_large_image",
      title,
      description,
      images: productDemoImg,
      ...args?.twitter,
    },
  };
}
